export enum DashboardSections {
  INPURCHASE_PROJECTS_SECTION = 'inPurchaseProjectsSection',
  ACTIVE_PROJECTS_SECTION = 'activeProjectsSection',
  COMPLETED_PROJECTS_SECTION = 'completedProjectsSection',
}
export enum BrandSettings {
  CUSTOMER = 'Customer',
  REFERRER = 'Referrer',
  RESELLER = 'Reseller',
  AGENCY = 'Agency',
  DISTRIBUTOR = 'Distributor',
  EVENT_PROVIDER = 'Event Provider',
}
export enum BrandCoolness {
  OLD_SCHOOL = 'Old School',
  BIT_OLD_SCHOOL = 'Bit Old School',
  OK = 'OK',
  PRETTY_COOL = 'Pretty Cool',
  COOL_AS = 'Cool as!',
}
export enum ProjectLevelLabels {
  LEVEL1 = 'PAYG',
  LEVEL2 = 'PAYG',
  LEVEL3 = 'PAYG',
  PREMIUM_PLUS = 'PAYG',
  OLD_ACCOUNT_LOAD = 'PAYG',
  SUBSCRIPTION_PACKAGE = 'PAYG',
  PRE_PAY_PACKAGE = 'Wallet',
  USAGE_PROJECT = 'Usage',
  PROPOSAL = 'Proposal',
  TEMPLATES = 'Templates',
  PAYG = 'PAYG',
}

export enum PayCycleLabels {
  FLEXIBLE = 'Flexible (any day)',
  WEEKLY = 'Weekly Payrun',
  MONTHLY = 'Monthly Payrun',
  END_OF_MONTH = 'End Of The Month',
  FROM_ISSUE_DATE = 'From Issue Date',
}

export enum PositionDefaultRole {
  DECISION_MAKER = 'Decision Maker',
  ACCOUNTS = 'Accounts',
  REVIEWER = 'Reviewer',
  OTHER = 'Other',
}
export enum PositionSecurityLevel {
  ADMINISTRATOR = 'Administrator',
  MEMBER = 'Member',
  RESTRICTED = 'Restricted',
}



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/enums/brand-dashboard.ts